<!-- 审核 -->
<template>
  <div class="diseaseList">
    <!-- TODO:封装selectForm筛选 -->
    <el-form :inline="true">
      <!-- <el-button type="primary" size="small" v-waves @click="handleAdd"
        >新增</el-button
      >-->
      <!-- <el-form-item
        label="所属门店:"
        style="margin: 20rpx 20rpx 0 20rpx"
        size="small"
      >
        <el-select
          v-model="listQuery.store_id"
          placeholder="请选择"
          clearable
          multiple
          collapse-tags
        >
          <div v-for="(item, index) in filterStoreList" :key="index">
            <el-option
              :label="item.store_name"
              :value="item.store_id + ''"
            ></el-option>
          </div>
        </el-select>
      </el-form-item>-->

      <el-form-item label="订单编号: " style="margin: 20rpx 20rpx 0 20rpx" size="small">
        <el-input v-model="listQuery.orderNumber" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="微信交易流水号: " style="margin: 20rpx 20rpx 0 20rpx" size="small">
        <el-input v-model="listQuery.transaction_id" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="订单状态:" style="margin: 20rpx 20rpx 0 20rpx" size="small">
        <el-select v-model="listQuery.status" placeholder="请选择" clearable>
          <div v-for="(item, index) in stateList" :key="index">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="支付方式:" style="margin: 20rpx 20rpx 0 20rpx" size="small">
        <el-select v-model="listQuery.payStyle" placeholder="请选择" style="width: 100%" clearable>
          <div v-for="(item, index) in payStyleList" :key="index">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>-->
      <el-form-item label="手机号: " style="margin: 20rpx 20rpx 0 20rpx" size="small">
        <el-input v-model="listQuery.phone" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="时间: " style="margin: 20rpx 20rpx 0 20rpx" size="small">
        <el-date-picker
          v-model="listQuery.date"
          type="daterange"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="getListData" size="small" v-waves>搜索</el-button>
      <!-- <el-button type="primary" @click="handleAdd" size="small" v-waves>发起订单</el-button> -->
      <el-button
        class="addBtn"
        type="primary"
        size="small"
        v-waves
        style="margin-right: 20px"
        :loading="downloadLoading"
        icon="el-icon-document"
        @click="handleDownload"
      >导出当页数据 Excel</el-button>
    </el-form>
    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="productCode" slot-scope="scope">
          <span v-if="scope.row.productCode">{{ scope.row.productCode }}</span>
          <span v-else>-</span>
        </template>
        <template slot="productName" slot-scope="scope">
          <span v-if="scope.row.productName">{{ scope.row.productName }}</span>
          <span v-else>-</span>
        </template>
        <template slot="num" slot-scope="scope">
          <span v-if="scope.row.num">{{ scope.row.num }}</span>
          <span v-else>-</span>
        </template>
        <template slot="price" slot-scope="scope">
          <span v-if="scope.row.price">{{ scope.row.price }}</span>
          <span v-else>-</span>
        </template>
        <template slot="sub_orderNumber" slot-scope="scope">
          <span v-if="scope.row.sub_orderNumber">{{ scope.row.sub_orderNumber }}</span>
          <span v-else>-</span>
        </template>

        <template slot="logisticsNumber" slot-scope="scope">
          <span
            v-if="scope.row.index"
          >{{scope.row.logisticsNumber?(scope.row.logisticsNumber+'(合并发货)'):'-'}}</span>
          <span v-else>{{ scope.row.logisticsNumber?scope.row.logisticsNumber:'-'}}</span>
        </template>

        <template slot="status" slot-scope="scope">
          {{
          arrayByIdToNameStr({
          ArrayData: stateList,
          ID: scope.row.status
          })
          }}
        </template>

        <template slot="payStyle" slot-scope="scope">
          <!-- <el-tag
            effect="dark"
            type="success"
            size="mini"
          >-->
          {{
          arrayByIdToNameStr({
          ArrayData: payStyleList,
          ID: scope.row.payStyle,
          })
          }}
          <!-- </el-tag> -->
        </template>

        <template slot="admin_id" slot-scope="scope">
          {{
          arrayByIdToNameStr({
          ArrayData: accountList,
          ID: scope.row.admin_id,
          })
          }}
        </template>
        <template slot="admin_pay_id" slot-scope="scope">
          {{
          arrayByIdToNameStr({
          ArrayData: accountList,
          ID: scope.row.admin_pay_id,
          })
          }}
        </template>

        <template slot="type">简古香铺</template>
        <!-- <template slot="detail" slot-scope="scope">
          <div>
            <el-tag
              effect="dark"
              size="mini"
            >线下取货码:{{ scope.row.takeCode ? scope.row.takeCode : "暂无" }}</el-tag>
          </div>
          <div
            v-for="(item, index) in scope.row.productList"
            :key="index"
            style="margin: 5px 0"
            class="productList"
          >
            <div class="productCode">商品编码 {{item.productCode?item.productCode:'-'}}</div>
            <div class="productName">
              {{ item.productName +
              (item.sku ? "(" + item.sku + ")" : "") }}
            </div>
            <div>单价 {{item.price?item.price:'-'}}</div>
            <div>数量 {{item.num?item.num:'-'}}</div>
          </div>
        </template>-->

        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button
              size="mini"
              type="text"
              @click="handleEdit(row)"
              primary
              v-if="row.index"
            >订单详情</el-button>
            <el-button
              size="mini"
              type="text"
              @click="handleSend(row)"
              primary
              v-if="!row.index"
              :disabled="userInfo.id !== 1"
            >物流单号填写</el-button>
            <el-button
              size="mini"
              type="text"
              @click="handleDelete(row)"
              style="color: rgb(255, 0, 0)"
              v-if="row.index  && userInfo.id == 1"
            >删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>

    <!-- 订单详情弹窗 -->
    <el-dialog title="订单详情" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="dialogForm" label-width="120px">
        <el-form-item label="订单状态:">
          <el-select
            v-model="dialogForm.status"
            placeholder="请选择"
            style="width: 100%"
            clearable
            :disabled="userInfo.id != 1"
          >
            <div v-for="(item, index) in stateList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
          <div>
            <el-tag
              effect="dark"
              size="mini"
            >线下取货码:{{ dialogForm.takeCode ? dialogForm.takeCode : "暂无" }}</el-tag>
          </div>
        </el-form-item>

        <el-form-item label="姓名">
          <el-input clearable v-model="dialogForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input clearable v-model="dialogForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="收货地址">
          <el-input type="textarea" clearable v-model="dialogForm.address"></el-input>
        </el-form-item>
        <el-form-item label="订单备注">
          <el-input type="textarea" clearable v-model="dialogForm.odescribe"></el-input>
        </el-form-item>
        <!-- <el-form-item label="支付方式">
          <el-select v-model="dialogForm.payStyle" placeholder="请选择" style="width: 100%" disabled>
            <div v-for="(item, index) in payStyleList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="企业主账户ID" style="margin: 20rpx 20rpx 0 20rpx" size="small">
          <el-input v-model="dialogForm.admin_id" placeholder="请输入" disabled></el-input>
        </el-form-item>
        <el-form-item label="下单会员账户ID" style="margin: 20rpx 20rpx 0 20rpx" size="small">
          <el-input v-model="dialogForm.admin_pay_id" placeholder="请输入" disabled></el-input>
        </el-form-item>-->
        <el-form-item
          label="微信交易流水号"
          style="margin: 20rpx 20rpx 0 20rpx"
          size="small"
          v-if="dialogForm.payStyle==3"
        >
          <el-input v-model="dialogForm.transaction_id" placeholder="请输入" disabled></el-input>
        </el-form-item>
        <!-- 发货单号 -->
        <!-- <el-form-item label="发货单号" v-if="userInfo.id == 1">
          <el-input clearable v-model="dialogForm.logisticsNumber" placeholder="物流单号"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 商品发货弹窗 -->
    <el-dialog title="发货" :visible.sync="dialogVisible_goods" :close-on-click-modal="false">
      <el-form ref="form" :model="dialogForm" label-width="80px">
        <!-- <el-form-item label="订单状态:">
          <el-select v-model="dialogForm.status" placeholder="请选择" style="width: 100%" clearable>
            <div v-for="(item, index) in stateList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>-->
        <!-- <el-form-item label="姓名">
          <el-input clearable v-model="dialogForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input clearable v-model="dialogForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="收货地址">
          <el-input type="textarea" clearable v-model="dialogForm.address"></el-input>
        </el-form-item>
        <el-form-item label="订单备注">
          <el-input type="textarea" clearable v-model="dialogForm.odescribe"></el-input>
        </el-form-item>-->
        <el-form-item label="商品编码">
          <el-input clearable v-model="dialogForm.productCode" disabled></el-input>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input clearable v-model="dialogForm.productName" disabled></el-input>
        </el-form-item>
        <el-form-item label="数量">
          <el-input clearable v-model="dialogForm.num" disabled></el-input>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input clearable v-model="dialogForm.logisticsNumber" placeholder="请填写物流单号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible_goods = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save_goods">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
// import filterQueryFormItems from "./filterQueryFormItems";
import Percentage from "@/components/filters/Percentage.vue";
import FillingStatus from "@/components/filters/FillingStatus.vue";
import KindTab from "@/components/tab/kindTab/index.vue";
// import waves from "@/directive/waves/index.js"; // 水波纹指令
import {
  addOrder,
  updateOrder,
  selectOrder,
  deleteOrder,
  updateProduct
} from "@/services/mall/order";
import { mapState } from "vuex";
import { arrayByIdToNameStr } from "@/utils/arrayByIdToNameStr";
import { selectAdmin } from "@/services/system/user.js";
export default {
  components: {
    ElTable,
    Percentage,
    FillingStatus,
    KindTab
  },
  async created() {
    this.getListData();
    this.selectAccountList();
  },
  // directives: {
  //   waves,
  // },
  data() {
    return {
      arrayByIdToNameStr,
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      /* 表格数据 */
      tableData: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogVisible_goods: false,
      dialogForm: {},
      stateList: [
        // { id: 0, name: "全部" },
        { id: 1, name: "待支付" },
        { id: 2, name: "待发货" },
        { id: 3, name: "已发货" },
        { id: 4, name: "已完成" },
        { id: 5, name: "退款中" },
        { id: 6, name: "已退款" }
      ],

      payStyleList: [
        { id: 1, name: "微信支付" },
        { id: 2, name: "会员账户余额" },
        { id: 3, name: "微信支付" },
        { id: 4, name: "积分兑换" }
      ],
      accountList: [],
      downloadLoading: false
    };
  },
  computed: {
    // filterQueryFormItems,
    listHeader,
    ...mapState(["userInfo", "filterStoreList"])
  },
  watch: {},
  methods: {
    async selectAccountList() {
      const { data, code, count } = await selectAdmin({
        pageNumber: 1,
        pageSize: 1000
        // grade: 2
      });
      if (code === 200) {
        this.accountList = data.map(item => {
          return {
            // ...item,
            name: item.alias_name,
            id: item.id
          };
        });
      }
    },
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      // listQuery.store_id =
      //   listQuery.store_id?.join(",") || this.userInfo.store_id;
      this.loading = true;
      const { data, code, count } = await selectOrder({
        ...listQuery,
        grade: this.userInfo.grade,
        admin_id: this.userInfo.id
      });
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    /* 搜索按钮 */
    async search(listQuery) {
      this.listQuery = listQuery;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建订单";
      this.dialogForm = {};
    },

    /* 修改 */
    handleEdit(row) {
      this.dialogVisible = true;
      this.dialogName = "编辑订单";
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    handleSend(row) {
      this.dialogVisible_goods = true;
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    /* 发货 */
    save_goods() {
      updateProduct({
        id: this.dialogForm.id,
        logisticsNumber: this.dialogForm.logisticsNumber
      }).then(res => {
        if (res.code === 200) {
          this.getListData();
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.dialogVisible_goods = false;
        }
      });
    },

    /* 保存订单信息 */
    save() {
      if (!this.dialogForm?.id) {
        addOrder(this.dialogForm).then(res => {
          console.log("创建订单", res);
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.getListData();
            this.$message({
              type: "success",
              message: "创建成功!"
            });
            this.dialogVisible = false;
          }
        });
      } else {
        updateOrder(this.dialogForm).then(res => {
          console.log("编辑订单", res);
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "保存成功!"
            });
            this.dialogVisible = false;
          }
        });
      }
    },

    /* 删除订单 */
    handleDelete(row) {
      console.log(row.id);
      this.$confirm("此操作将永久删除该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row.id);
          deleteOrder({ id: row.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },

    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },
    /* 导出数据 */
    handleDownload() {
      this.downloadLoading = true;
      import("@/utils/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "订单状态",
          "订单编号",
          "物流单号",
          "商品编码",
          "商品名称",
          "下单数量",
          "价格",
          "订单总额",
          "订单支付总额",
          "订单创建时间",
          "姓名",
          "手机号",
          "地址",
          "支付方式",
          // "企业主账户",
          // "下单会员账户",
          "微信交易流水号"
        ];
        const filterVal = [
          "status",
          "orderNumber",
          "logisticsNumber",
          "productCode",
          "productName",
          "num",
          "price",
          "cost",
          "realityCost",
          "createTime",
          "name",
          "phone",
          "address",
          "payStyle",
          // "admin_id",
          // "admin_pay_id",
          "transaction_id"
        ];
        const list = this.tableData.map(item => {
          return {
            ...item,

            status: arrayByIdToNameStr({
              ArrayData: this.stateList,
              ID: item.status
            }),

            payStyle: arrayByIdToNameStr({
              ArrayData: this.payStyleList,
              ID: item.payStyle
            }),
          };
        });
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "订单数据下载",
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    }
  }
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}

.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}

.productList {
  // border: 1px solid rgb(52, 52, 52);
  display: flex;
  // align-items: center;
  > div {
    background: rgb(234, 234, 234);
    margin: 2px;
    padding: 3px 5px;
    width: 120px;
  }
  .productName {
    width: 250px;
  }
  .productCode {
    width: 350px;
  }
}
</style>
